<template>
	<div>
		<v-card elevation="0" :style="'background-color:' + $theme.lightBlue">
			<v-card-title style="font-size: large">
				<v-icon size="20" v-if="listIcon.length > 0" color="black" style="margin-right: 10px">{{ listIcon }}</v-icon>
				{{ listTitle }}
			</v-card-title>
			<v-data-table
				:style="'cursor: pointer;background-color:' + $theme.lightBlue"
				:headers="headers"
				:items="items"
				:search="search"
				@click:row="showItem"
				:items-per-page="20"
				:footerProps="{ 'items-per-page-options': [20, 50, 100, -1] }"
			>
				<template v-slot:top>
					<tr class="d-flex justify-space-between">
						<td style="width: 200px; margin-right: 20px"></td>
						<td>
							<v-btn
								style="margin-top: 10px; margin-right: 10px"
								rounded
								:color="$theme.primary"
								dark
								elevation="0"
								@click="
									clearItem();
									newItemDialog = true;
								"
							>
								<v-icon dark>mdi-plus</v-icon> 추가
							</v-btn>
						</td>
					</tr>
				</template>

				<!-- 여기에서 말줄임 텍스트에 툴팁 추가 및 개행 처리 -->
				<template v-slot:item.content="{ item }">
					<v-tooltip bottom>
						<template v-slot:activator="{ on, attrs }">
							<span v-bind="attrs" v-on="on">
								<span v-text="truncateText(item.content)"></span>
							</span>
						</template>
						<span v-html="formatMessage(item.content)"></span>
					</v-tooltip>
				</template>

				<template v-slot:item.displayStartAt="{ item }">
					{{ formatTimestamp(item.displayStartAt) }}
				</template>
				<template v-slot:item.displayEndAt="{ item }">
					{{ formatTimestamp(item.displayEndAt) }}
				</template>
				<template v-slot:item.createAt="{ item }">
					{{ formatTimestamp(item.createAt) }}
				</template>
				<template v-slot:item.updateAt="{ item }">
					{{ formatTimestamp(item.updateAt) }}
				</template>
				<template v-slot:item.message="{ item }">
					<div v-html="formatMessage(item.message)"></div>
				</template>
			</v-data-table>
		</v-card>

		<BannerEditDialog
			:show="newItemDialog"
			:item="selectedItem"
			icon="mdi-plus"
			title="배너 추가"
			okButtonText="확인"
			cancelButtonText="취소"
			@onOk="registItem"
			@onCancel="
				selectedItem = $models.BannerModel.create();
				newItemDialog = false;
			"
		>
		</BannerEditDialog>

		<BannerEditDialog
			:show="editDialog"
			:item="selectedItem"
			icon="mdi-pencil"
			title="수정"
			okButtonText="확인"
			cancelButtonText="취소"
			:deleteButton="true"
			deleteButtonText="삭제"
			@onOk="modifyItem"
			@onCancel="
				selectedItem = $models.BannerModel.create();
				editDialog = false;
			"
			@onDelete="deleteItemConfirm"
		>
		</BannerEditDialog>

		<message-dialog
			:show="deleteMessageDialog"
			message="삭제하시겠습니까?"
			:okButton="true"
			cancelButtonText="취소"
			:deleteButton="true"
			deleteButtonText="삭제"
			@onOk="deleteItem"
			@onCancel="deleteMessageDialog = false"
		/>
	</div>
</template>

<script>
	import { formatTimestamp, formatMessage, truncateText } from '@/js/util';

	export default {
		name: 'BannerList',
		props: {
			listIcon: {
				default: '',
			},
			listTitle: {
				default: '',
			},
			items: {
				default: [],
			},
		},
		data: () => ({
			search: '',
			selectedItem: {},
			deleteMessageDialog: false,
			formValid: false,
			newItemDialog: false,
			editDialog: false,
			headers: [
				{
					text: '제목',
					align: 'start',
					sortable: true,
					value: 'title',
				},
				{
					text: '내용',
					align: 'start',
					sortable: true,
					value: 'content',
				},
				{
					text: '배너 유형',
					align: 'start',
					sortable: true,
					value: 'bannerTypeName',
				},
				{
					text: '노출 위치 유형',
					align: 'start',
					sortable: true,
					value: 'displayPositionTypeName',
				},
				{
					text: '대상 사용자 유형',
					align: 'start',
					sortable: true,
					value: 'displayTargetUserTypeName',
				},
				{
					text: '정렬 순서',
					align: 'start',
					sortable: true,
					value: 'sort',
				},
				{
					text: '노출 여부',
					align: 'start',
					sortable: true,
					value: 'displayTypeName',
				},
				{
					text: '노출시작일시',
					align: 'start',
					sortable: true,
					value: 'displayStartAt',
				},
				{
					text: '노출종료일시',
					align: 'start',
					sortable: true,
					value: 'displayEndAt',
				},
				{
					text: '생성일시',
					align: 'start',
					sortable: true,
					value: 'createAt',
				},
				{
					text: '수정일시',
					align: 'start',
					sortable: true,
					value: 'updateAt',
				},
			],
		}),
		methods: {
			formatMessage,
			formatTimestamp,
			truncateText,
			deleteItemConfirm() {
				this.deleteMessageDialog = true;
			},
			showItem(item) {
				this.selectedItem = this.$models.BannerModel.set(item);
				this.selectedItem.id = item.id;
				this.editDialog = true;
			},
			clearItem() {
				this.selectedItem = this.$models.BannerModel.create();
			},
			async registItem(item) {
				this.selectedItem = this.$models.BannerModel.set(item);
				this.$emit('registItem', this.selectedItem);
				this.newItemDialog = false;
				this.clearItem();
			},
			async modifyItem(item) {
				this.selectedItem = this.$models.BannerModel.set(item);
				this.selectedItem.id = item.id;
				this.$emit('modifyItem', this.selectedItem);
				this.editDialog = false;
				this.clearItem();
			},
			async deleteItem() {
				this.$emit('deleteItem', this.selectedItem.id);
				this.deleteMessageDialog = false;
				this.editDialog = false;
			},
		},
	};
</script>

<style scoped></style>
